import { render, staticRenderFns } from "./InitQuote.vue?vue&type=template&id=40be3020&scoped=true&"
import script from "./InitQuote.vue?vue&type=script&lang=js&"
export * from "./InitQuote.vue?vue&type=script&lang=js&"
import style0 from "./InitQuote.vue?vue&type=style&index=0&id=40be3020&prod&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be3020",
  null
  
)

export default component.exports